import { RootState } from "RootReducer";
import { createShipmentInitialMetaState } from "../CreateShipmentState";

// providing fallback, a lot of legacy integration tests may encounter this selector
export const selectCreateShipmentMeta = (state: RootState) =>
  state.createShipment?.meta ?? createShipmentInitialMetaState;
